import React from 'react';
import { HeadingFour, SmallText, colors } from 'hui';
import styled from 'styled-components';
import ErrorIcon from './images/fail-to-load.png';

const StyledFrame = styled.div`
  border-color: ${colors.tint6};
  background: ${colors.tint6};
  text-align: center;
  padding: 20px;
`;

const ErrorPlaceholder = () => {
  return (
    <StyledFrame>
      <img src={ErrorIcon} />
      <HeadingFour bold>Sorry we&apos;re having some technical issues</HeadingFour>
      <SmallText>Please try refreshing the page</SmallText>
    </StyledFrame>
  );
};

export default ErrorPlaceholder;
